import * as React from "react";
import { DropdownItemProps, Grid, Icon, Select } from "semantic-ui-react";

import { ControlOption, SliderComponent } from "./components";

interface Props {
  disableCameraChanges: boolean;
  onChangeSpeed(speed: number): void;
  onChangeTextSize(textSize: number): void;

  onChangeCamera(deviceId: string): void;
  onChangeMicrophone(deviceId: string): void;

  cameraOptions: DropdownItemProps[];
  microphoneOptions: DropdownItemProps[];
  selectedCamera: string | undefined;
  selectedMicrophone: string | undefined;

  aspectRatio: number;
  onAspectRatioChange: (ar: number) => void;
  canChangeAspectRatio?: boolean;
  warningMessage?: string;
}

const ControlSectionFC: React.FC<Props> = ({
  disableCameraChanges,
  onChangeSpeed,
  onChangeTextSize,
  onChangeCamera,
  onChangeMicrophone,
  cameraOptions,
  microphoneOptions,
  selectedCamera,
  selectedMicrophone,
  aspectRatio,
  onAspectRatioChange,
  canChangeAspectRatio,
  warningMessage,
}) => {
  // pixels per second
  const [speed, setSpeed] = React.useState<number>(15);
  const [textSize, setTextSize] = React.useState<number>(23);

  const MIN_SPEED = 0; // Slowest scroll
  const MAX_SPEED = 55; // Fastest scroll

  const aspectRatioOptions: DropdownItemProps[] = [
    { text: "Vertical", value: 9 / 16 },
    { text: "Horizontal", value: 4 / 3 },
  ];

  React.useEffect(() => {
    onChangeSpeed(speed);
  }, [speed, onChangeSpeed]);

  React.useEffect(() => {
    onChangeTextSize(textSize);
  }, [textSize, onChangeTextSize]);

  return (
    <Grid.Row>
      <ControlOption title="Text Size">
        <SliderComponent min={15} max={36} name="textSize" onChange={setTextSize} step={1} value={textSize} />
      </ControlOption>

      <ControlOption title="Auto-scroll Speed">
        <SliderComponent min={MIN_SPEED} max={MAX_SPEED} name="speed" onChange={setSpeed} step={5} value={speed} />
      </ControlOption>

      {cameraOptions && cameraOptions.length > 0 && (
        <ControlOption title="Camera">
          <Select
            placeholder="Camera"
            onChange={(_, data) => onChangeCamera(`${data.value}`)}
            options={cameraOptions}
            value={selectedCamera}
            disabled={disableCameraChanges}
          />
        </ControlOption>
      )}

      <ControlOption title={"Orientation"}>
        <Select
          placeholder={"Choose an aspect ratio"}
          onChange={(_, data) => onAspectRatioChange(Number(data.value))}
          options={aspectRatioOptions}
          value={aspectRatio}
          disabled={canChangeAspectRatio}
        />
      </ControlOption>

      {microphoneOptions && microphoneOptions.length > 0 && (
        <ControlOption title="Microphone">
          <Select
            placeholder="Microphone"
            onChange={(_, data) => onChangeMicrophone(`${data.value}`)}
            options={microphoneOptions}
            value={selectedMicrophone}
            disabled={disableCameraChanges}
          />
        </ControlOption>
      )}

      {warningMessage && warningMessage.length > 0 && (
        <div className="mt-2.5 mr-5 rounded-md border border-[#db0a0a] p-2.5">
          <Icon name="warning sign" color={"orange"} />
          {warningMessage}
        </div>
      )}
    </Grid.Row>
  );
};

export const ControlSection = ControlSectionFC;
